<template>
  <v-app-bar color="primary" app bottom style="width: 100vw; z-index: 6;" height="70" flat>
    <v-row align="end">
      <v-col cols="auto">
        <div
          class="text-caption white--text d-flex align-center justify-space-between"
        >
          <span class="mb-1">Progresso:</span>
          <span>{{ progress }}%</span>
        </div>

        <v-progress-linear
          :value="progress"
          :color="!$vuetify.theme.dark ? 'success' : 'white'"
          height="20"
          :style="{
            width: $vuetify.breakpoint.smAndUp ? '180px' : '160px',
            border: $vuetify.theme.dark ? '1px solid #000' : 'none'
          }"
        ></v-progress-linear>
      </v-col>

      <v-spacer></v-spacer>

      <v-col cols="auto">
        <!-- Botão Voltar -->
        <v-btn
          color="white"
          outlined
          :width="$vuetify.breakpoint.smAndUp ? 130 : 40"
          class="white--text mr-4"
          :disabled="$route.path === '/'"
          @click="goPrev"
        >
          <div v-if="$vuetify.breakpoint.smAndUp">Voltar</div>
          <div v-else>
            <v-icon>mdi-arrow-left</v-icon>
          </div>
        </v-btn>

        <!-- Botão Avançar -->
        <v-btn
          color="white"
          depressed
          :width="$vuetify.breakpoint.smAndUp ? 130 : 40"
          class="primary--text"
          @click="goNext"
            :disabled="$route.path === '/referencias' || isCurrentRouteActivity"
        >
          <div v-if="$vuetify.breakpoint.smAndUp">Avançar</div>
          <div v-else>
            <v-icon>mdi-arrow-right</v-icon>
          </div>
        </v-btn>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    isCurrentRouteActivity() {
      // Verifica se a rota atual contém '-atividade'
      return this.$route.path.includes('-atividade');
    },
    progress() {
      return this.$store.state.progresso_topicos.LMS_Progress ;
    }
  },
  methods: {
    goNext() {
  // Obtenha o índice da rota atual no array de rotas
  const filteredRoutes = this.$router.options.routes.filter(
    (route) => !route.path.includes('-atividade') // Exclua rotas que contêm '-atividade'
  );

  const currentRouteIndex = filteredRoutes.findIndex(
    (route) => route.path === this.$route.path
  );

  // Verifique se existe uma próxima rota
  if (currentRouteIndex !== -1 && currentRouteIndex < filteredRoutes.length - 1) {
    // Navegue para a próxima rota
    const nextRoute = filteredRoutes[currentRouteIndex + 1];
    this.$router.push(nextRoute.path);
  } else {
    // Caso seja a última rota, exiba uma mensagem ou tome outra ação
    console.log("Você está na última rota válida.");
  }
},
    goPrev() {
      // Voltar para a rota anterior
      this.$router.go(-1);
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style>
.v-progress-linear__buffer {
  background: white;
}
</style>
